<template>
    <div class="action-profile-updated">
        <div class="title f-bold" v-html="$translate('ACTION_PROFILE_UPDATED')" />
        <div class="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionProfileUpdated',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            return this.$translate('ACTION_PROFILE_UPDATED_BODY')
        },
    },
}
</script>
